import React, { useState, useEffect, useCallback } from 'react'
import { Box, Typography, Button, ListItem, Chip, useTheme, OutlinedInput, ClickAwayListener, InputBase } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import SelectBox from '../CustomizedUIs/CustomSelectBox'
import colors from '../CustomizedUIs/Colors'
import CustomPoper from '../CustomizedUIs/CustomPoper'
import { useDataProvider, useTranslate, Loading } from 'react-admin'
import { Link, useHistory } from "react-router-dom";
import TextField from '../CustomizedUIs/CustomTextFiled'
import { red, pink } from '@material-ui/core/colors';
import DeleteIcon from '../assets/icons/primary-blue-bin.png'
import { Search, DoneAll, ClearAll } from '@material-ui/icons'
import Checkbox from '../checkbox'
import TextButton from '../CustomizedUIs/TextButton'

const bgColorError = pink['50'];
const textColorError = red['700'];

const useStyles = makeStyles(theme => ({

    borderImage: {
        borderRadius: '10px',
        backgroundColor: '#c1e5fa',
        '&:hover': {
            backgroundColor: '#a7cce7',
        }
    }
    , borderUpImange: {
        width: '500px',
        height: ' 145px',
        borderRadius: ' 10px',
        boxShadow: '0 5px 15px 0 rgba(0, 0, 0, 0.05)',
        backgroundColor: ' #ffffff',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    TextSearch: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#88898c',
        '&::placeholder': {
            color: '#88898c',
            opacity: 1
        }
    },
    input: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: '100%',
        cursor: 'pointer',
        opacity: 0,
    },
    TitleImage: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    TextValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.385,
        letterSpacing: '0.13px',
        color: '#88898c',
    },

    titleDateRoom: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
        paddingBottom: 8
    },
    large: {
        marginLeft: 16,
        border: '1px solid #ddd',
        background: 'white',
        borderRadius: 4,
        padding: 5,
        width: 150,
        height: 100,
        '&:hover': {
            boxShadow: '0 0 2px 1px rgba(0, 140, 186, 0.5)'
        }
    },
}));

const FilterInput = ({ onChangeValue, value, name, open }) => {
    const classes = useStyles()
    return (
        <Box display='flex' style={{ borderRadius: '8.1px', border: ' solid 0.8px #f1f2f4', backgroundColor: "#f7f7f7" }}>
            <Search style={{ color: '#b4b5bd', size: '18px', margin: 'auto 2px auto 5px' }} />
            <InputBase
                autoFocus={open === true ? true : false}
                value={value}
                onChange={onChangeValue}
                placeholder={"Filter " + name}
                inputProps={{
                    'aria-label': 'search',
                    className: classes.TextSearch
                }}
                style={{ width: '180px' }}
            />
        </Box>
    )
}


const FormUpdate = ({ remoteId, loading, setLoading, setLoadingSave, setName }) => {
    const classes = useStyles()
    const translate = useTranslate()
    const history = useHistory()
    const dataProvider = useDataProvider()
    const [anchorEl, setAnchorEl] = useState(null);
    const [keyData, setKeyData] = useState([])
    const [openPoper, setOpenPopper] = useState(false);
    const [keys, setkeys] = useState([])
    const [openKeys, setOpenKeys] = useState(false)
    const [messsageError, setMessageError] = useState('')
    const [filterKey, setFilterKey] = useState('');
    const [keyAvailable, setKeyAvailable] = useState([])
    const [textValue, setTextValue] = useState({
        name: '',
        description: '',
    })
    const [error, setError] = useState({
        name: { status: remoteId ? false : true, messsage: '' },
    })

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const onChangTextValue = (event, name) => {

        setTextValue({
            ...textValue, [name]: event.target.value
        })
        if (name === 'name' || name === 'uri') {
            if (event.target.value === '')
                setError({
                    ...error, [name]: { status: true, messsage: 'required' }
                })
            else
                setError({
                    ...error, [name]: { status: false, messsage: '' }
                })
        }
    }

    const onEdit = () => {
        let nameRep = null, codeRep = null;
        console.log('......', keyData);
        keyData.forEach((item, index) => {
            let name = keyData.findIndex(e => e.name === item.name);
            if (name > -1 && name !== index) {
                nameRep = item.name;
            }
            let code = keyData.findIndex(e => e.keyCode && hasMatchingKey(e.keyCode.split(','), item.keyCode.split(',')));
            if (code > -1 && code !== index) {
                codeRep = item.keyCode;
            }
        });
        if (nameRep) {
            window.scrollTo(0, 0);
            setMessageError(`Failed to create remote control: duplicate key name "${nameRep}"`);
        }
        else if (codeRep) {
            window.scrollTo(0, 0);
            setMessageError(`Failed to create remote control: duplicate key code "${codeRep}"`);
        }
        else {
            setLoadingSave(true)
            dataProvider('UPDATE', "remotes", {
                id: remoteId,
                data: {
                    name: textValue.name,
                    description: textValue.description,
                    keys: keyData
                }
            }).then(response => {
                history.push({
                    pathname: '/remote',
                    state: { open: true, name: textValue.name, message: translate(`pos.categories.editFolder.success`) }
                });
                setLoadingSave(false)
            }).catch(error => {
                window.scrollTo(0, 0);
                if (error.message === 'exist')
                    setMessageError('Name exist')
                if (error.message === 'Existing name')
                    setMessageError('Existing name')
                setLoadingSave(false)
            });
        }

    }

    const hasMatchingKey = (a, b) => {
        let result = false;
        a.forEach(e => {
            if (b.indexOf(e) !== -1)
                result = true;
        }
        );
        return result;
    }

    const pickkeysValue = (value) => {
        const currentKeys = [...keys];
        if (value && value.checked) {
            currentKeys.push(value);
        }
        else {
            const matchingkeys = currentKeys.find(k => k.name === value.name);
            if (matchingkeys) {
                currentKeys.splice(currentKeys.indexOf(matchingkeys), 1);
            }
        }
        setkeys(currentKeys)
    }

    const changeKeyText = (index, name, event) => {
        let temps = [...keyData];
        temps[index][name] = event.target.value || '';
        setKeyData(temps);
    }

    const addKey = () => {
        setMessageError('');
        let temps = [...keys];
        const customKeys = keyData;//.filter(e => isCustomKey(e));
        let keyDatas = [...customKeys];
        const dupkeys = [];
        keyDatas.forEach(e => {
            temps.forEach(t => {
                if (e.name === t.name) {
                    dupkeys.push(t);
                }
            })
        });
        let unionKeys = [...keys, ...customKeys];

        dupkeys.forEach(e => {
            unionKeys.splice(unionKeys.findIndex(ue => e.name === ue.name && ue.keyCode === e.keyCode), 1);
        })
        setKeyData(unionKeys);
        setOpenKeys(false);
        setkeys([]);
    }

    const isCustomKey = (k) => {
        return keyAvailable.every(e => e.name !== k.name);
    }

    const addCustomKey = () => {
        setMessageError('');
        let temps = [...keyData];
        temps.push({ keyText: '', keyCode: '0', name: '' });
        setKeyData(temps);
    }
    const deleteKey = (index) => {
        let temps = [...keyData]
        temps.splice(index, 1)
        setKeyData(temps);
        updateMapping(temps);
    }

    const onChangeFilterKey = (e) => {
        setFilterKey(e.target.value)
    }

    const getKeyAvailable = () => {
        !loading && setLoading(true);
        dataProvider('GET_LIST', "get-keyavailable", {
            filter: {},
            pagination: {},
            sort: {},
        }).then(response => {
            setKeyAvailable(response.data);
            setLoading(false)
        }).catch(error => {
            setLoading(false)
        });
    }

    const getRemote = () => {
        !loading && setLoading(true)
        dataProvider('GET_ONE', "remotes", {
            id: remoteId

        }).then(({ data }) => {
            if (data) {
                setTextValue({
                    name: data.name,
                    description: data.description
                })
                setKeyData(data.keys)
                setName(data.name)
            }
            setLoading(false)
        })
    }

    const remoteKeyOnCheck = (e) => {
        if (e)
            e.checked = !e.checked;
        pickkeysValue(e);
    }

    const selectAllClick = () => {
        const temps = updateMapping(keyAvailable);
        const dupkeys = [];
        keyData.forEach(e => {
            if (temps.findIndex(t => e.name === t.name) !== -1)
                temps.splice(temps.findIndex(ue => e.name === ue.name), 1);
        });
        setkeys([...temps]);
    }

    const clearAllClick = () => {
        const temps = updateMapping([]);
        setkeys([...temps]);
    }

    useEffect(() => {
        getKeyAvailable();
        getRemote();
    }, []);

    useEffect(() => {
        updateMapping();
        setkeys([]);
    }, [keyAvailable, keyData])

    const updateMapping = (kd) => {
        let _keyData = keyData;
        if (kd)
            _keyData = kd;
        const temps = [];
        const _keyAvailable = keyAvailable;
        for (let idx = 0; idx < _keyAvailable.length; idx++) {
            const ka = _keyAvailable[idx];
            ka.checked = false;
            for (let jdx = 0; jdx < _keyData.length; jdx++) {
                const kd = _keyData[jdx];
                if (kd.name === ka.name) {
                    ka.checked = true;
                    if (temps.findIndex(te => te.name === ka.name) === - 1)
                        temps.push(ka);
                }
            }
        }
        setKeyAvailable(_keyAvailable);
        return temps;
    };

    if (loading) return <Loading />

    return (
        <ClickAwayListener onClickAway={() => setOpenKeys(false)}>
            <Box>
                {
                    messsageError != "" && (
                        <Box borderRadius='6px' my={1} width={500} bgcolor={bgColorError} py={1}>
                            <Typography variant='subtitle2' style={{ color: textColorError, margin: '1em' }}>{messsageError}</Typography>
                        </Box>
                    )
                }
                <Box my={2}>
                    <TextField
                        required
                        style={{ width: 530 }}
                        variant='filled'
                        label={translate(`pos.common.name`)}
                        error={error.name.status && error.name.messsage !== ''}
                        helperText={error.name.messsage}
                        onBlur={(event) => onChangTextValue(event, 'name')}
                        value={textValue.name}
                        onChange={(event) => onChangTextValue(event, 'name')}
                        endDom={<CustomPoper
                            open={openPoper}
                            anchorEl={anchorEl}
                            handleClick={handleClickOpenPoper}
                            handleClose={handleClosePoper}
                            title={translate(`pos.remoteControl.name`)}
                            content={translate(`pos.remoteControl.name_content`)}
                            icon={<b>?</b>}
                        />} />
                </Box>

                <Box my={2}>
                    <TextField
                        style={{ width: 530 }}
                        variant='filled'
                        label={translate(`pos.support.description`)}
                        multiline
                        rows={2}
                        value={textValue.description}
                        onChange={(event) => onChangTextValue(event, 'description')}
                        endDom={<CustomPoper
                            open={openPoper}
                            anchorEl={anchorEl}
                            handleClick={handleClickOpenPoper}
                            handleClose={handleClosePoper}
                            title={translate(`pos.support.description`)}
                            content={translate(`pos.remoteControl.description`)}
                            icon={<b>?</b>}
                        />} />
                </Box>
                <Box
                    px={2} py={1}
                    my={1}
                    bgcolor={colors.white['50']}
                    border={1}
                    borderColor={colors.lightBlue['200']}
                    borderRadius='4px'
                    width={500}>
                    <Box m={1}>
                        <Typography className={classes.titleDateRoom}>{translate(`pos.remoteControl.keys`)}</Typography>
                    </Box>
                    {
                        keyData.map((item, index) => (
                            <Box key={'key_' + index} style={{ border: `1px solid ${colors.lightBlue['200']}`, borderRadius: '4px' }} p={1} my={1} display='flex'>
                                <Box width={200} display='flex' px={1}>
                                    <Typography style={{ marginRight: '8px' }}>{translate(`pos.remoteControl.keyName`)}</Typography>
                                    <OutlinedInput
                                        id="outlined-name"
                                        value={item.name}
                                        onChange={(e) => changeKeyText(index, 'name', e)}
                                        aria-describedby="outlined-weight-helper-text"
                                        inputProps={{
                                            "aria-label": "weight",
                                            style: {
                                                padding: '8px',
                                                height: 10,

                                            }
                                        }}
                                        labelWidth={0}
                                    />

                                </Box>
                                <Box width={120} display='flex' px={1}>
                                    <Typography style={{ marginRight: '8px' }}>{translate(`pos.remoteControl.keyText`)}</Typography>
                                    <OutlinedInput
                                        id="outlined-text"
                                        value={item.keyText}
                                        onChange={(e) => changeKeyText(index, 'keyText', e)}
                                        aria-describedby="outlined-weight-helper-text"
                                        inputProps={{
                                            "aria-label": "weight",
                                            style: {
                                                padding: '8px',
                                                height: 10,

                                            }
                                        }}
                                        labelWidth={0}
                                    />
                                </Box>
                                <Box width={200} display='flex' px={1}>
                                    <Typography style={{ marginRight: '8px' }}>{translate(`pos.remoteControl.keyCode`)}</Typography>
                                    <OutlinedInput
                                        id="outlined-code"
                                        value={item.keyCode}
                                        onChange={(e) => changeKeyText(index, 'keyCode', e)}
                                        aria-describedby="outlined-weight-helper-text"
                                        inputProps={{
                                            "aria-label": "weight",
                                            style: {
                                                padding: '8px',
                                                height: 10,

                                            }
                                        }}
                                        labelWidth={0}
                                    />
                                </Box>
                                <Box display='flex' justifyContent='flex-end' alignItems='center' width={30}>
                                    <img src={DeleteIcon} style={{ cursor: 'pointer' }} width='15px' height='15px' onClick={() => deleteKey(index)}></img>
                                </Box>
                            </Box>
                        ))
                    }

                    <Box my={2} display='flex' width='100%'>
                        <Button style={{ marginRight: 16, marginTop: 20, width: '100px', height: 31 }} variant='contained' color='primary' onClick={addKey}>{translate(`pos.remoteControl.addKey`)}</Button>
                        <Box width='100%' position='relative'>
                            <Box position='absolute' top={0} right={0} width='100%' zIndex={2}>
                                {
                                    <SelectBox
                                        label={translate(`pos.remoteControl.keys`)}
                                        width='350px'
                                        value={
                                            keys && keys.filter(element => element.checked).length === 0 ? '' :
                                                <Box display='flex' style={{ marginLeft: '-30px' }}>
                                                    {
                                                        keys.filter((element) => element.checked).map((data, index) => {
                                                            if (index < 4)
                                                                return (
                                                                    <Chip
                                                                        color='primary'
                                                                        size='small'
                                                                        style={{ marginRight: index !== 3 ? 4 : 0 }}
                                                                        key={data.id}
                                                                        label={data.name}
                                                                    />
                                                                )
                                                        }
                                                        )

                                                    }
                                                    {
                                                        keys.filter((element, index) => element.checked).length > 4 &&
                                                        <Typography
                                                            variant='body1'>{translate(`pos.channels.more`)}</Typography>
                                                    }
                                                </Box>
                                        }
                                        open={openKeys}
                                        handleClick={() => {
                                            setOpenKeys(!openKeys)
                                        }}
                                    >
                                        <ListItem className={classes.boxBoder} style={{ padding: '8px 16px' }}>
                                            <FilterInput className={classes.textLabel} value={filterKey}
                                                onChangeValue={onChangeFilterKey} filterEntity
                                                name={'key'.toLowerCase()} open={openKeys} />
                                        </ListItem>
                                        <ListItem key={'keyav_'}
                                            style={{ padding: '8px 16px' }}>
                                            <Button onClick={() => selectAllClick()}>
                                                <DoneAll color='primary' style={{ margin: 'auto 2px auto 5px' }} />
                                                <Typography className={classes.TextValue}>{translate(`pos.remoteControl.selectAll`)}</Typography>
                                            </Button>
                                            {
                                                <Button onClick={() => clearAllClick()}>
                                                    <ClearAll color='primary' style={{ margin: 'auto 2px auto 5px' }} />
                                                    <Typography className={classes.TextValue}>{translate(`pos.remoteControl.clearAll`)}</Typography>
                                                </Button>
                                            }
                                        </ListItem>
                                        {
                                            keyAvailable.filter(item => item.name.toUpperCase().includes(filterKey.toUpperCase()) && keyData.findIndex(kd => kd.name === item.name) === -1)
                                                .map((item, index) => (
                                                    <ListItem key={'keyav_' + index} className={classes.boxBoder}
                                                        style={{ padding: '8px 16px' }} button
                                                        onClick={() => remoteKeyOnCheck(item)}>
                                                        <Checkbox color='primary'
                                                            checked={item.checked === undefined ? false : item.checked}></Checkbox>
                                                        <Typography
                                                            className={classes.TextValue}>{item.name}</Typography>
                                                    </ListItem>
                                                ))
                                        }
                                    </SelectBox>
                                }
                            </Box>

                        </Box>
                    </Box>
                    <Box my={2} display='flex' width='100%'>
                        <Button style={{ marginRight: 16, marginTop: 20, width: '150px', height: 31 }} variant='contained' color='primary' onClick={addCustomKey}>{translate(`pos.remoteControl.addCustomKey`)}</Button>
                    </Box>
                </Box>
                <Box my={2} display='flex' width={530} justifyContent='flex-end' alignItems='flex-end'>
                    <TextButton style={{ marginRight: '30px' }} component={Link} to={{ pathname: "/Remote" }}/>
                    <Button style={{ pading: 8 }} disabled={error.name.status} variant='contained' color='primary' onClick={onEdit}>
                        {
                            remoteId ? translate(`pos.common.save`) : translate(`pos.common.create`)
                        }
                    </Button>
                </Box>

            </Box >
        </ClickAwayListener>
    )


}
export default FormUpdate